import { BaseResponseMapper } from './Base'
import { Pagination } from '@/domain/entities/Pagination'
import { MasterCar, MasterCarData } from '@/domain/entities/MasterCar'
import { AxiosResponse } from 'axios'

export class MasterCarDataMapper extends BaseResponseMapper {
  public convertFromApi(result: AxiosResponse<any>): MasterCar {
    const { data } = result
    return new MasterCar(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new MasterCarData(
            val.id,
            val.name,
            val.tag,
            val.training_active,
            val.sop_active,
            val.image_thumbnail,
            val.image_cover,
            val.image_logo,
            val.created_at,
            val.updated_at
          )
      )
    )
  }
}
